import { render, staticRenderFns } from "./JanelaMensagens.vue?vue&type=template&id=2162c181&scoped=true&"
import script from "./JanelaMensagens.vue?vue&type=script&lang=js&"
export * from "./JanelaMensagens.vue?vue&type=script&lang=js&"
import style0 from "./JanelaMensagens.vue?vue&type=style&index=0&id=2162c181&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2162c181",
  null
  
)

export default component.exports